import './index.scss'

const LINKS = [
  { label: 'EMAIL', href: 'mailto:adam.botma@me.com', display: 'adam.botma@me.com' },
  {
    label: 'LINKEDIN',
    href: 'https://www.linkedin.com/in/adam-botma/',
    display: 'in/adam-botma',
    external: true,
  },
  {
    label: 'GITHUB',
    href: 'https://github.com/adam-botma',
    display: 'github.com/adam-botma',
    external: true,
  },
]

const Contact = () => (
  <div className='ct-root'>
    <div className='ct-inner'>
      <div className='ct-grid'>
        {/* ── Left ──────────────────────────────────────── */}
        <div className='ct-left'>
          <div className='ct-eyebrow'>( CONTACT )</div>

          <h1 className='ct-lead'>
            <span className='ct-lead__bright'>Let's build something.</span> Available for full-stack
            engineering, ecommerce, and the messy problems in between — reach out, or grab a time on
            my calendar.
          </h1>

          <a
            className='ct-cal-btn'
            href='https://calendly.com/adam-botma-1/30min'
            target='_blank'
            rel='noopener noreferrer'>
            <span className='ct-cal-btn__icon'>
              <svg
                width='17'
                height='17'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'>
                <rect x='3' y='4' width='18' height='18' rx='2' />
                <path d='M16 2v4M8 2v4M3 10h18' />
              </svg>
            </span>
            Schedule a call
          </a>
          <div className='ct-cal-sub'>Opens Calendly — pick a slot that works for you.</div>

          <div className='ct-spacer' />

          <div className='ct-rows'>
            {LINKS.map(({ label, href, display, external }) => (
              <a
                key={label}
                className='ct-row'
                href={href}
                {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                <span className='ct-row__label'>{label}</span>
                <span className='ct-row__value'>{display}</span>
                <span className='ct-row__arrow'>↗</span>
              </a>
            ))}
          </div>
        </div>

        {/* ── Right: photo ──────────────────────────────── */}
        <div className='ct-photo'>
          <img src='/images/contactus.jpg' alt='' className='ct-photo__img' />
        </div>
      </div>
    </div>
  </div>
)

export default Contact
